import { Card } from '@yleisradio/areena-types';
import { useAreenaService } from 'contexts/AreenaServiceContext';
import { useUILanguage } from 'hooks/useUILanguage';
import { JsonLd } from 'react-schemaorg';
import type { ListItem } from 'schema-dts';
import { pointerToCanonicalURL } from 'utils/pointer';

type Props = {
  cards: Card[];
};

export const ListMetadata: React.FC<Props> = ({ cards }) => {
  const { areenaService: service = 'tv' } = useAreenaService();
  const language = useUILanguage();

  if (cards.length === 0) {
    return null;
  }

  return (
    <JsonLd
      item={{
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement: cards.map((card, index): ListItem => {
          const url =
            card.pointer &&
            pointerToCanonicalURL(card.pointer, language, service);

          return {
            '@type': 'ListItem',
            position: index + 1,
            ...(url && { url }),
          };
        }),
      }}
    />
  );
};
